module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUxpcf////////////////////////////////////////////////////////////////Hv/K4AAAAQdFJOUwAK81UkRQHA2u0xy5D6g6dqlcgvAAAAuklEQVQoz32T6xLEEAyFLUrCVvP+T7sRal1a55fxzUTOSSh1KyQPWoNPQU1yBqgJjOuZjTQo2j87kCbh0dhJi85KLdKDUCq7SI+KuStDLzIMYbm9ruKIvS/sq1yhQaWVcY9ySso/sE+59PVJOFfGj2ppwdUgekZaYLYkdGAMc1kMJcSRcVk5CzUT44aKFawT7hlbqSEUOjAO4Y4vT2Fk0AWPdmQSfBsZwjqy7bD3a7JfsP1q7pf65Tv8AENjIR+f8xyfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/icon_succeed.png
// module id = 594
// module chunks = 0